export default "__VITE_ASSET__BHPmzLkM__"